import { render } from "./AsideRight.vue?vue&type=template&id=3687d77b"
import script from "./AsideRight.vue?vue&type=script&lang=js"
export * from "./AsideRight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__